<template>
	<div class="tpl my-integral-wrap">
		<mt-header title="我的积分" fixed>
			<router-link :to="{name:'mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="integral-header">
			<img src="../../assets/img/mine/center_img_mark_bg.png" alt="" />
			<div class="show-integral">
				<p><span>{{integralInfo.integral_sum}}</span>积分</p>
				<p>已连续签到 {{integralInfo.sign_times}} 天</p>
			</div>
			<div class="sign-btn" @click="goSign">{{isSign==0?"点击签到":"已签到"}}</div>
			<div class="integral-list">
				<div class="line"></div>
				<ul>
					<li v-for="item in signs">
						<p>{{item.date}}</p>
						<img v-if="item.is_sign" src="../../assets/img/mine/center_ic_ok.png" alt="" />
						<img v-else src="../../assets/img/mine/center_ic_no.png" alt="" />
					</li>
				</ul>

			</div>
		</div>
		<div class="integral-option">
			<div class="option-item" @click="showAlert=1">
				<img src="../../assets/img/mine/center_mark_list_1.png" alt="" /> 积分规则
			</div>
			<div class="option-item" @click="showIntegralDetail">
				<img src="../../assets/img/mine/center_mark_list_2.png" alt="" /> 积分明细
			</div>
		</div>
		<div class="task-list">
			<p class="list-title">
				<span class="name"><img src="../../assets/img/finds/ic_list_tab@2x.png"/>每日任务</span>
				<span class="more" :class="{'active':showTaskMore==1}" @click="showTaskMore=!showTaskMore">更多<img src="../../assets/img/mine/center_mark_ic_list_down.png"/></span>
			</p>
			<ul>
				<li v-if="taskList[0]">
					<span class="name">{{taskList[0].name}}<span>+{{taskList[0].integral}}积分</span></span>
					<button v-if="taskList[0].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[1]">
					<span class="name">{{taskList[1].name}}<span>+{{taskList[1].integral}}积分</span></span>
					<button v-if="taskList[1].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[2]">
					<span class="name">{{taskList[2].name}}<span>+{{taskList[2].integral}}积分</span></span>
					<button v-if="taskList[2].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[3]&&showTaskMore">
					<span class="name">{{taskList[3].name}}<span>+{{taskList[3].integral}}积分</span></span>
					<button v-if="taskList[3].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[4]&&showTaskMore">
					<span class="name">{{taskList[4].name}}<span>+{{taskList[4].integral}}积分</span></span>
					<button v-if="taskList[4].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[5]&&showTaskMore">
					<span class="name">{{taskList[5].name}}<span>+{{taskList[5].integral}}积分</span></span>
					<button v-if="taskList[5].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[6]&&showTaskMore">
					<span class="name">{{taskList[6].name}}<span>+{{taskList[6].integral}}积分</span></span>
					<button v-if="taskList[6].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[7]&&showTaskMore">
					<span class="name">{{taskList[7].name}}<span>+{{taskList[7].integral}}积分</span></span>
					<button v-if="taskList[7].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[8]&&showTaskMore">
					<span class="name">{{taskList[8].name}}<span>+{{taskList[8].integral}}积分</span></span>
					<button v-if="taskList[8].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[9]&&showTaskMore">
					<span class="name">{{taskList[9].name}}<span>+{{taskList[9].integral}}积分</span></span>
					<button v-if="taskList[9].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
				<li v-if="taskList[10]&&showTaskMore">
					<span class="name">{{taskList[10].name}}<span>+{{taskList[10].integral}}积分</span></span>
					<button v-if="taskList[10].sum==0" class="no">去完成</button>
					<button v-else class="yes">已完成</button>
				</li>
			</ul>
		</div>
		<div class="change-money">
			<p class="list-title">
				<span class="name"><img src="../../assets/img/finds/ic_list_tab@2x.png"/>兑换桃花币</span>
			</p>
			<div class="change-num">
				<span>兑换数量</span>
				<span class="edit-num">
					<span @click="delExchangeCoin"><img src="../../assets/img/mine/center_mark_ic_little.png"/></span>
					<input type="number" v-model="exchangeCoinNum" />
					<span @click="addExchangeCoin"><img src="../../assets/img/mine/center_mark_ic_more.png"/></span>
				</span>
			</div>
			<p class="change-tip">兑换所需积分：{{exchangeCoinNum*100}}</p>
			<p class="change-btn">
				<button @click="exchangeCoin">立即兑换</button>
			</p>
		</div>
		<common-alert v-if="showAlert" @hideAlert="hideAlert">
			<p slot="title" class="title">{{alertInfo.title}}</p>
			<div class="content" slot="content" v-html="alertInfo.text"></div>
		</common-alert>
	</div>
</template>

<script>
	
	import moment from "moment"
	import CommonAlert from "../Common/CommonAlert"
	
	export default {
		name: "my-integral",
		components:{
			CommonAlert
		},
		data() {
			return {
				uid: "",
				integralInfo:"",	//积分信息
				taskList:[],	//任务列表
				signList:[],	//接口返回的签到列表
				signs:[],	//处理后的签到列表
				isSign:0,
				showTaskMore:0,
				exchangeCoinNum:1,
				showAlert:0,
				alertInfo:{
					title:"积分怎么兑换鱼币？",
					text:"<p>1：积分可通过平台做任务获得，也可通过充值桃花币获得（1桃花币=100积分）</p><p>2：积分不可转增其他用户</p><p>3：积分的数值精确到个位（小数点后全部舍弃，不进行四舍五入）</p><p>积分只可兑换桃花币，积分兑换成功后将从会员账户中扣减相应的积分分值，但不会影响您在平台上的等级</p>"
				}
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			console.log(this.getWeek(0))
			
			this.getMyIntegral();
			
			
		},
		methods: {
			getMyIntegral(){
				this.$axios({
					url:"My/UserIntegralCheckInList",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res.data.data);
					if(res.data.code==200){
						this.integralInfo = res.data.data.integral;
						this.taskList = res.data.data.daily_tasks;
						this.signList = res.data.data.sign_in;
						
						this.createSignList();
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getWeek(i) {
				var now = new Date();
				var firstDay = new Date(now - (now.getDay() - 1) * 86400000);
				firstDay.setDate(firstDay.getDate() + i);
				var mon = Number(firstDay.getMonth()) + 1;
				return  mon + "." + firstDay.getDate();
			},
			createSignList(){
				var _this = this;
				let arr = []
				for(let i=0;i<7;i++){
					arr.push(this.getWeek(i),)
				}
				let nowDate = ((new Date()).getMonth()+1)+"."+(new Date()).getDate();
				let signs = this.signList;
				signs = signs.map(function(item){
					return moment(item.create_time*1000).format("M.D");
				})
//				console.log(signs.includes(nowDate));
				if(signs.includes(nowDate)){
					this.isSign = 1
				}
//				console.log(this.isSign)
//				console.log(signs)
				let res = arr.map(function(item){
					let a = {};
					a.date = item;
					a.is_sign = 0;
//					console.log(signs.includes(item))
					if(signs.includes(item)){
						a.is_sign = 1;
					}else{
						a.is_sign = 0;
					}
					if(item==nowDate){
						a.date = "今天"
					}else{
						a.date = item
					}
					return a;
				})
				this.signs = res;
			},
			goSign(){
				this.$axios({
					url:"My/UserIntegralCheckIn",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
						this.getMyIntegral();
					}else if(res.data.code==300){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
					}
				}).catch(err=>{
					console.log(err);
					this.$toast({
						message: "签到失败",
						position: "bottom",
						duration: 3000
					});
				})
			},
			showIntegralDetail(){
				this.$router.push({name:"my-integral-detail"})
			},
			addExchangeCoin(){
				this.exchangeCoinNum++;
			},
			delExchangeCoin(){
				if(this.exchangeCoinNum>1){
					this.exchangeCoinNum--;
				}else{
					this.$toast({
						message: "不能再减啦~",
						position: "bottom",
						duration: 3000
					});
					this.exchangeCoinNum = 1;
				}
			},
			exchangeCoin(){
				this.$axios({
					url:"My/UserExchange",
					method:"post",
					data:{
						uid:this.uid,
						integral_exchange:this.exchangeCoinNum*100
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code== 200||300){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
					}
				}).catch(err=>{
					console.log(err);
					this.$toast({
						message: "兑换失败！",
						position: "bottom",
						duration: 3000
					});
				})
			},
			
			hideAlert(){
				this.showAlert = 0
			}
		}
	}
</script>

<style scoped>
	.my-integral-wrap {
		padding-top: 2.5rem;
	}
	
	.integral-header {
		position: relative;
	}
	
	.integral-header>img {
		width: 100%;
		display: block;
	}
	
	.integral-header .show-integral {
		position: absolute;
		top: 3rem;
		left: 2rem;
		font-size: 0.8rem;
		color: #fff;
		line-height: 1.6rem;
	}
	
	.integral-header .show-integral p span {
		font-size: 1.6rem;
		margin-right: 5px;
	}
	
	.integral-header .sign-btn {
		position: absolute;
		top: 6rem;
		right: 0;
		background: #fbda30;
		box-shadow: 0 0 0.5rem #5415F9;
		padding: 0.3rem 0.2rem 0.3rem 1rem;
		border-radius: 2rem 0 0 2rem;
		font-size: 0.8rem;
		color: #5415F9;
	}
	
	.integral-header .sign-btn:active {
		opacity: 0.7;
	}
	
	.integral-header .integral-list {
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		padding: 0.7rem 1rem;
		background: url(../../assets/img/mine/center_img_mark_bg1.png) no-repeat;
		background-size: 100%;
		background-position: 0 bottom;
	}
	
	.integral-header .integral-list ul {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;
		z-index: 2;
	}
	
	.integral-header .integral-list ul li {
		text-align: center;
		color: #fff;
		font-size: 0.8rem;
		line-height: 1.2rem;
	}
	
	.integral-header .integral-list ul li img {
		width: 1.7rem;
		display: block;
	}
	
	.integral-header .integral-list .line {
		position: absolute;
		bottom: 1.55rem;
		left: 2rem;
		width: 80%;
		border-bottom: 1px solid #FDF294;
		z-index: 0;
	}
	
	.integral-option {
		margin-bottom: 0.5rem;
	}
	
	.integral-option,
	.integral-option .option-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.integral-option .option-item {
		justify-content: center;
		flex: 1;
		padding: 0.8rem 0;
		background: #fff;
		color: #282828;
		font-size: 0.9rem;
	}
	
	.integral-option .option-item:active {
		background: #fafafa;
	}
	
	.integral-option .option-item:first-of-type {
		border-right: 1px solid #f3f3f3;
	}
	
	.integral-option .option-item img {
		width: 2rem;
		margin-right: 0.8rem;
	}
	
	.list-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		padding: 0.5rem;
	}
	
	.list-title span {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.list-title span.name {
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	
	.list-title span.name img {
		width: 1.2rem;
		margin-right: 0.5rem;
	}
	
	.list-title span.more {
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	
	.list-title span.more img {
		width: 1.5rem;
		transition:500ms
	}
	.list-title span.active img {
		transform: rotate(180deg);
	}
	
	.task-list li {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.7rem 0.8rem 0.7rem 2rem;
		background: #fff;
		border-top: 1px solid #f3f3f3;
		font-size: 0.8rem;
		color: #282828;
	}
	
	.task-list li .name span {
		color: #FF6161;
		margin: 0 0.3rem;
	}
	
	.task-list li button {
		border: 1px solid #4E05FF;
		background: none;
		outline: 0;
		color: #4E05FF;
		font-size: 0.8rem;
		padding: 0.25rem 1rem;
		border-radius: 2rem;
	}
	
	.task-list li button.yes {
		border: 1px solid #7b7b7b;
		color: #7b7b7b;
	}
	
	.task-list li button.no:active {
		background: #4E05FF;
		color: #fff;
	}
	
	.change-money {
		margin-top: 0.5rem;
	}
	
	.change-money .change-num {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.7rem 0.8rem 0.7rem 2rem;
		background: #fff;
		border-top: 1px solid #f3f3f3;
	}
	
	.change-money .change-num input {
		width: 2.5rem;
		border: 0;
		border-left: 1px solid #5415F9;
		border-right: 1px solid #5415F9;
		outline: 0;
		height: 1.6rem;
		text-align: center;
		color: #5415F9;
	}
	
	.change-money .change-num span {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.change-money .change-num span img {
		width: 0.8rem;
		margin: 0 0.4rem;
	}
	
	.change-money .change-num .edit-num {
		border: 1px solid #5415F9;
		border-radius: 2rem;
		padding: 0 0.2rem;
	}
	
	.change-money .change-tip {
		background: rgba(78, 5, 255, .1);
		padding: 0.8rem 2rem;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	
	.change-money .change-btn {
		background: #fff;
		padding: 1.5rem;
		text-align: center;
	}
	
	.change-money .change-btn button {
		width: 60%;
		height: 2.5rem;
		background: linear-gradient(45deg, rgba(118, 68, 250, 1) 0%, rgba(156, 124, 255, 1) 100%);
		border-radius: 4px;
		border: 0;
		outline: 0;
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyIntegral.vue